import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";

const PromoBanner = () => {
  return (
    <Link 
      to="/book/JavitsAdvancedRez"
      className="block bg-accent text-white py-3.5 px-4 text-center hover:bg-accent/90 transition-all duration-300 shadow-lg"
    >
      <div className="flex items-center justify-center gap-2 font-bold">
        <Sparkles className="w-5 h-5 animate-pulse" />
        <span className="text-base md:text-lg tracking-wide uppercase">
          Now Live at the Javits Center — Click here to book
        </span>
        <ArrowRight className="w-5 h-5" />
      </div>
    </Link>
  );
};

export default PromoBanner;
